import { connect } from 'react-redux'
import { doFetchAccountIntegrationData } from 'actions/sidebar_cards'
import {
  selectIntegrationCredentialsForId,
  selectCanDisplayForCurrentTicketMailbox,
} from 'ducks/integrations'
import {
  doFetchEvents,
  doFetchOrders,
  doFetchShopInfo,
  selectIsLoading,
} from 'ducks/integrations/shopify'
import logo from 'assets/integrations/shopify.png'
import withCardDataLoading from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/withCardDataLoading'

import View from './view'

const selectFactory = (initialState, initialOwnProps) => {
  const { id: cardId } = initialOwnProps
  const openStateKey = `shopify-${cardId}`
  return state => {
    return {
      errorMessage:
        'Please check your Shopify credentials in your settings and try again.',
      image: logo,
      key: openStateKey,
      openStateKey,
      integration: selectIntegrationCredentialsForId(state, {
        id: cardId,
      }),
      showCard: selectCanDisplayForCurrentTicketMailbox(state, cardId),
      isLoading: selectIsLoading(state),
    }
  }
}

const performFactory = (initialState, initialOwnProps) => {
  const { id: cardId } = initialOwnProps
  return dispatch => ({
    load: customerId =>
      dispatch(doFetchAccountIntegrationData('shopify', cardId, customerId)),
    fetchShop: integrationId => dispatch(doFetchShopInfo(integrationId)),
    fetchEvents: (integrationId, customerGid, limit) =>
      dispatch(doFetchEvents(integrationId, customerGid, limit)),
    fetchOrders: (integrationId, customerGid, limit) =>
      dispatch(doFetchOrders(integrationId, customerGid, limit)),
  })
}

export default connect(selectFactory, performFactory)(
  withCardDataLoading(View, { useInAppCardView: false, canReload: true })
)
